
import { component } from '@/helpers/vueTyped';

export default component()({
  name: 'NoContentPage',

  render() {
    return (
      <div class='no-content'>
        Sorry, there is no content currently available
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-1a7882d0/NoContentPage.vue" });